// OperatingModeのグローバル定数定義
// App.tsxのグローバルスケーリング基準サイズ
export const BASE_W = 1280;
export const BASE_H = 800;
